import type { AstComment } from "@ext/git/core/Diff/logic/commentsDiff/CommentsDiff";
import type { Node } from "prosemirror-model";

const collectComments = (doc: Node): AstComment => {
	const comments: AstComment = {};

	doc.descendants((node, pos) => {
		if (!node.isText) return;

		const id = node.marks.find((mark) => mark.type.name === "comment")?.attrs.id;
		if (!id) return;

		const from = pos;
		const to = pos + node.nodeSize - 1;

		comments[id] = comments[id]
			? { from: Math.min(comments[id].from, from), to: Math.max(comments[id].to, to) }
			: { from, to };
	});

	return comments;
};

export default collectComments;
